import axios from 'axios';

const defaultAxiosConfig = (accessToken) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: accessToken
  }
});

/**
 * GET /users/search — admin session; matches email, phone, first/last name, DOB (backend).
 * @param {{ search: string, limit?: number, offset?: number }} params
 */
class UserSearchApi {
  async searchUsers({ search, limit = 50, offset = 0 }) {
    const accessToken = window.localStorage.getItem('accessToken');
    const response = await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/users/search`,
      params: {
        search: search.trim(),
        limit,
        offset
      },
      ...defaultAxiosConfig(accessToken)
    });

    return response.data;
  }
}

export const userSearchApi = new UserSearchApi();
